module.exports = __webpack_public_path__ + "img/folio-tablet.766ddfa.jpg";